import { render, staticRenderFns } from "./SuperDocAnswerMessage.vue?vue&type=template&id=9bbf8b32&scoped=true"
import script from "./SuperDocAnswerMessage.vue?vue&type=script&lang=js"
export * from "./SuperDocAnswerMessage.vue?vue&type=script&lang=js"
import style0 from "./SuperDocAnswerMessage.vue?vue&type=style&index=0&id=9bbf8b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbf8b32",
  null
  
)

export default component.exports